import { IconWrapper, IconWrapperProps } from './IconWrapper';

interface EditIconProps extends IconWrapperProps {}

export const EditIcon = ({ ...props }: EditIconProps) => (
  <IconWrapper {...props}>
    <path
      d="M7.68603 0.246781C7.86354 0.0692697 8.15134 0.0692697 8.32885 0.246781L10.7531 2.67102C10.9306 2.84853 10.9306 3.13634 10.7531 3.31385L4.08643 9.98051C4.00119 10.0658 3.88557 10.1136 3.76502 10.1136H1.34078C1.08974 10.1136 0.88623 9.91014 0.88623 9.6591V7.23486C0.88623 7.11431 0.93412 6.99869 1.01936 6.91345L7.68603 0.246781Z"
      fill="#333333"
    />
  </IconWrapper>
);

EditIcon.displayName = 'EditIcon';
